<template>
  <div class="choose_cashier_cont" v-if="visible">
    <div class="choose_cashier_pop_up">
      <h2>Choose Cashier</h2>

      <div class="contoo">
        <div class="row cashier_list" v-if="cashiersWithSelection.length">
            <div
            v-for="cashier in cashiersWithSelection"
            :key="cashier.id"
            :class="['cashier_item', { cashier_item_selected: cashier.selected }]"
            @click="select_cashier(cashier)"
            >
            <img :src="linkk + '/' + cashier.profile_pic" />
            <div class="cashier_name">{{ cashier.name }}</div>
            </div>
        </div>

      <div class="err" v-if="show_err && show_err !== null">
        <!-- must select cashier -->
        <span>{{ show_err }}</span>
      </div>

      </div>




      <button class="save_cashier_btn" @click="save_selected_cashier">
        Let's Go
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChooseCashierPopUp",

  props: {
    visible: {
      type: Boolean,
      required: true
    },
    cashiers: {
      type: Array,
      required: true
    },
    linkk: {
      type: String,
      default: process.env.VUE_APP_API_URL
    }
  },

  emits: ["close"],

  data() {
    return {
      cashiersWithSelection: [],
      show_err: null
    };
  },

  watch: {
    cashiers: {
      immediate: true,
      handler(newVal) {
        // clone عشان نضيف selected لكل كاشير
        this.cashiersWithSelection = newVal.map(c => ({
          ...c,
          selected: c.id ===  Number(localStorage.getItem('cashier_id'))
        }));
      }
    }
  },

  methods: {
    select_cashier(cashier) {
        this.show_err = null;
      this.cashiersWithSelection.forEach(c => {
        c.selected = c.id === cashier.id;
      });
    },

    save_selected_cashier() {
        this.show_err = null;
      const selected = this.cashiersWithSelection.find(c => c.selected);
      if (!selected) {
        // alert("Please select a cashier");
        this.show_err = 'Must select a cashier';
        return;
      }

      localStorage.setItem("cashier_id", selected.id);

    //   if route is login go to admin if not just close and stay on the same page
    //   if (this.$route.name === "login"){
    //     this.$router.push({ name: "admin" });
    //   }else{
        this.$emit("close");
    //   }
    }
  }
};
</script>

<style scoped>



.choose_cashier_cont{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.choose_cashier_pop_up{
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 90%;
    max-width: 400px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* make .cashier_item image circle and but cashier name under it and make it responsive */
.cashier_item{
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    margin: 10px;

    background-color: #cccccc5e;
    border-radius: 5px;
    padding: 15px;
    border: 2px solid #ccc;

}
.cashier_item img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 5px;
}
.cashier_name{
    font-size: 16px;
    font-weight: 500;
}

/* change it cool shade of blue */
.cashier_item_selected{
    border: 2px solid #317BEB;
    background-color: #d0e4ff;
}

.save_cashier_btn{
    padding: 10px 25px;
    margin-top: 15px;
}

button{
    background-color: #317BEB;
    border: 0px;
    padding: 7px 0px;
    color: #F2F2F2;
    font-size: 18px;
    font-family: 'Poppins', sans-serif !important;
    font-weight: 500;
    border-radius: 3px;
    cursor: pointer;
    text-align: center;
}

/* make .err with slight red color as background and text red and bold */
.err{
    background-color: #FFC0CB;
    color: #FF0000;
    font-weight: 500;
    padding: 10px;
    border-radius: 3px;
    margin-top: 10px;
    border: 1px solid #FF0000;
}

</style>